const Partners = () => {
  const partList = [
    "/images/part1.png",
    "/images/part2.png",
    "/images/part3.png",
    "/images/part4.png",
    "/images/part5.png",
    "/images/part6.png",
    "/images/part7.png",
    "/images/part8.png",
    "/images/part9.png",
    "/images/part10.png",
    "/images/part11.png",
    "/images/part12.png",
    "/images/part13.png",
    "/images/part14.png",
    "/images/part15.png",
    "/images/part16.png",
    "/images/part17.png",
    "/images/part18.png",
    "/images/part19.png",
    "/images/part20.png",
    "/images/part21.png",
    "/images/part22.png",
    "/images/part23.png",
    "/images/part24.png",
    "/images/part25.png",
    "/images/part26.png",
    "/images/part27.png",
    "/images/part28.png",
    "/images/part29.png",
    "/images/part30.png",
    "/images/part31.png",
    "/images/part32.png",
    "/images/part33.png",
    "/images/part34.png",
    "/images/part35.png",
  ];

  return (
    <div
      id="partners"
      className="relative w-full h-full py-14 lg:py-28 px-[calc((100%-var(--container))/2)]"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <div className="relative w-full h-fit flex justify-center items-end flex-nowrap sm:flex-wrap gap-3">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-fit lg:w-full h-full max-h-10 lg:max-h-14 object-contain"
              alt="싹치워드림 로고"
              src="/images/logo.png"
              width={593}
              height={136}
            />
          </div>
        </div>
      </div>
      <div className=" relative w-full h-full py-10 grid grid-cols-2 lg:grid-cols-5 gap-2 lg:gap-5">
        {partList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full border border-black px-1 py-2"
          >
            <img
              className="!relative w-auto max-w-32 h-20 mx-auto object-contain"
              alt={`싹치워드림 협력 제휴업체 로고 ${i + 1}`}
              src={v}
              width={500}
              height={500}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
